import React, { useState, useEffect } from 'react';
import { getRandomProductImage } from '../utils/images';

const About: React.FC = () => {
  const [aboutImage, setAboutImage] = useState<string>('');

  // Set the about image only once when component mounts
  useEffect(() => {
    setAboutImage(getRandomProductImage());
  }, []);
  return (
    <section id="about" className="py-20 bg-[#0a3d34] text-[#f0e1b2]">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <h2 className="font-serif text-4xl font-bold border-b-2 border-[#d4af37] pb-2 inline-block">Our Soulful Fusion Story</h2>
            <p className="text-lg leading-relaxed text-gray-200">
              Born from a passion for authentic Hyderabadi flavors and a love for modern culinary twists, Urban Zaikha is the premier cloud kitchen bringing desi soul to the Dallas-Fort Worth metroplex. Our motto is simple: "Modern cravings, desi soul."
            </p>
            <p className="text-lg leading-relaxed text-gray-200">
             We specialize in Hyderabadi fusion, creating a symphony of flavors that honors our rich heritage while exciting the modern palate. From our kitchen to your home, we offer convenient delivery for orders over $15. Planning a special event? We also provide catering services and offer complimentary taste testing to ensure your menu is perfect.
            </p>
          </div>
          <div>
            <img 
              src={aboutImage} // Use the stable about image
              alt="Delicious Hyderabadi fusion dish" 
              className="rounded-lg shadow-2xl object-cover w-full h-full transform transition-transform duration-500 hover:scale-105"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
